import { render } from "./table.vue?vue&type=template&id=184d273e&scoped=true&ts=true"
import script from "./table.vue?vue&type=script&lang=ts"
export * from "./table.vue?vue&type=script&lang=ts"

import "./table.vue?vue&type=style&index=0&id=184d273e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184d273e"]])

export default __exports__